// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__25g3T","header":"ReportDetails_header__2kmD0","title":"ReportDetails_title__2skPE","left":"ReportDetails_left__342gf"};